// Strings for S6. Only the S6 worker edits this file (see web/README.md).
// One screen, branched by disruption type (ux-flow.md S6). Copy from prototype/assets/app.js
// (screens.S6, the docgate sheet); DRAFT = no source there (w2-03 report).
export default {
  // Working name for the loading state's document title; the question itself titles the page.
  title: 'The legal question',
  'delayed.q': 'How late did you arrive in {city} ({iata})?',
  'missed.q': 'How late did you reach {city} ({iata})?',
  'missed.sub': 'Measured at your final destination, not the airport where you changed planes.',
  'delay.3h': '3 hours or more',
  'delay.under3h': 'Less than 3 hours',
  'delay.never': 'I never arrived',
  // w5-06 (Q39): over 3,500 km (the quote's band `long`), "3 hours or more" is split: 3–4 h pays half.
  'delay.4hOrMore': '4 hours or more', // decision 39's wording
  'delay.3to4h': '3–4 hours', // decision 39's wording
  'delay.longHaulNote':
    'On a flight this long, 3 to 4 hours late pays half, and more than that pays in full.', // DRAFT
  // 1.4 (w8-04, decisions 145, 146): the delay question when the data can't decide. The unsure
  // answer is decision 145's wording; the rest is DRAFT (the task's wording, no prototype source).
  'delay.unsure': "I don't know, but I believe it was 3 hours or more", // decision 145's wording
  'delay.how':
    'We count the delay at your final destination, against the scheduled arrival on your ticket, until the doors opened and you could get off, not when the wheels touched down.', // DRAFT
  // Why we ask, by the resolver's `delayQuestion` (a missed connection keeps `missed.sub`).
  'why.landed': "Our data shows the landing, not when the doors opened, so we're asking you.", // DRAFT (no_gate_data, touchdown known)
  'why.noData': "We don't know when the doors opened on this flight, so we're asking you.", // DRAFT (no_gate_data, nothing or an estimate)
  'why.yourView': 'Tell us what you experienced.', // DRAFT (disputed, gate_under_3h)
  // What our data shows when it says under 3 hours, without arguing: the answer decides (146).
  'data.landed': 'Our data shows it landed {delay} after schedule.', // DRAFT
  'data.landedOnTime': 'Our data shows it landed on time.', // DRAFT
  'data.gate': 'Our data shows it reached the gate {delay} after schedule.', // DRAFT
  'data.gateOnTime': 'Our data shows it reached the gate on time.', // DRAFT
  'data.decides': "We'll go by your answer.", // DRAFT
  'note.label': 'Anything that helps (optional)', // DRAFT
  'note.placeholder': 'When the doors opened, a long wait on the plane…', // DRAFT
  'cancelled.q': 'How far in advance were you told about the cancellation?',
  'cancelled.lt14': 'Less than 14 days',
  'cancelled.ge14': '14 days or more',
  'cancelled.notTold': "I wasn't told at all",
  'denied.q': 'Did you volunteer to give up your seat for benefits?',
  'denied.no': 'No, I was turned away',
  'denied.yes': 'Yes, I volunteered',
  'gate.title': 'Did you have the right documents?',
  'gate.note': 'A valid passport, any visa you needed, and a booking for this flight.',
  'gate.yes': 'Yes, continue',
  'gate.no': 'No — I was missing something',
  saveFailed: "That didn't save. Check your connection and try again.", // DRAFT
} as const;
